/* src/app/shared/funcionalidade-desabilitada/funcionalidade-desabilitada.component.scss */
/*# sourceMappingURL=funcionalidade-desabilitada.component.css.map */
